import React, { useState } from "react";
import Background from "@/components/landing/Background";
import AppHeader from "@/components/nav/AppHeader";
import AppSidebar from "@/components/nav/AppSidebar";
import BottomTabBar from "@/components/nav/BottomTabBar";

/**
 * AppShell — wraps all authed pages with the unified navigation chrome.
 *
 *   ┌────────────────────────────────────┐
 *   │  AppHeader (sticky)                │
 *   ├──────────┬─────────────────────────┤
 *   │ Sidebar  │   <children>            │
 *   │ (lg+)    │                         │
 *   ├──────────┴─────────────────────────┤
 *   │  BottomTabBar (md and below)       │
 *   └────────────────────────────────────┘
 *
 *  Pages should render their own <main> body (kept as `children`).
 *  Sidebar/BottomTabBar can be hidden per-page via `noChrome=true` if needed.
 */
export default function AppShell({ children, testid = "app-shell", noChrome = false, containerClass = "container-mx py-10" }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="min-h-screen relative" data-testid={testid}>
            <Background />
            <div className="relative z-10 flex flex-col min-h-screen">
                <AppHeader
                    mode="app"
                    onToggleSidebar={noChrome ? undefined : () => setSidebarOpen(true)}
                />
                <div className="flex flex-1">
                    {!noChrome && (
                        <AppSidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                    )}
                    <main className={`flex-1 min-w-0 pb-[72px] md:pb-0 ${containerClass}`}>
                        {children}
                    </main>
                </div>
                {!noChrome && <BottomTabBar />}
            </div>
        </div>
    );
}
